export const ADR_PALLET_MESSAGE = 'ADR.palletRequired';

export function hasAdr(parcel) {
  return !!parcel && Array.isArray(parcel.dangerous_goods) && parcel.dangerous_goods.length > 0;
}

export function allowsAdr(shipment, packaging) {
  // A new copy belongs to the cabinet, even when copied from a Dachser shipment.
  return !!(shipment && shipment.id > 0 && shipment.adr_packaging_exempt === true)
    || !!(packaging && packaging.standard === true);
}
